import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import CronJobsConsole from "../components/cronjobs/CronJobsConsole";

const AdminCronJobsPage = () => {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <CronJobsConsole />;
};

export default AdminCronJobsPage;
